import { Immutable } from "immer";
import React from "react";
import { useStaticURL } from "tsi-common-react/src/utils/urls";

import type { WhyMediaSection as Value } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./index.module.scss";

type IProps = Immutable<{
    value: Value | null;
}>;

/**
 * Faithful JSX transcription of the legacy sealy
 * ``components/media_sections/why-pp_media_section.html`` (#33285). The block
 * is a value-less StaticBlock: the serialized value is an empty object (or
 * null on the standalone template path) and is ignored.
 */
export const WhyMediaSection = (_props: IProps): React.JSX.Element => {
    const staticURL = useStaticURL();
    return (
        <section className={styles.weight}>
            <div className="container">
                <img
                    className={concatClassNames([
                        styles.weightBackground,
                        "img-responsive",
                    ])}
                    src={`${staticURL}img/media-section/banner-whypp-cutaway.png`}
                    alt="Why Sealy"
                    loading="lazy"
                    decoding="async"
                />

                <div className={styles.weightContent}>
                    <img
                        className={styles.weightIcon}
                        src={`${staticURL}img/media-section/icon-bed.png`}
                        alt="Bed Icon"
                        loading="lazy"
                        decoding="async"
                    />

                    <h5 className={styles.weightHeadline}>
                        Did you know?
                        <br />
                        50% of your body weight rests in the middle while you
                        sleep.
                    </h5>
                    <p className="weight__copy alt-copy">
                        That&apos;s why we&apos;ve engineered Posturepedic
                        Technology to reinforce the center to support your back
                        and core.
                    </p>
                </div>
            </div>
        </section>
    );
};
